import React, { useEffect, useState } from "react";
import TextInfo from "@/bit/components/components.text";
import CmsDetailCardList from "@/bit/components/components.cms-block.cms-detail-card-list";
import CollapsedDetailCardList from "@/bit/components/components.cms-block.cms-collapsed-detail-card-list";
import Alert from "@/bit/components/components.cms-block.cms-alert";
import SecureLocalStorage from "@gcloud-npm/utils.secure.local-storage";
import FilterButtons from "./button-list";

function filterByCategory(list, category) {
  return (
    list?.filter(
      (item) =>
        item &&
        item.category &&
        item.category.includes &&
        item.category.includes(category),
    ) || []
  );
}

function renderCardList({
  cards,
  cardProps,
  cmsHandler,
  blockName,
  innerBlockName,
  alias,
  index,
}) {
  if (cards?.length > 0) {
    return (
      <CmsDetailCardList
        {...{ ...cardProps, "cms-ml-detail-card-1": cards, visible: true }}
        cmsHandler={cmsHandler}
        key={`filter-card-row--${index}`}
        blockName={`${blockName}.${innerBlockName}`}
        alias={alias}
      />
    );
  }
  return null;
}

const FilterCards = (props) => {
  const {
    cmsHandler,
    blockName,
    "cms-filter-button-list-1": buttonList,
    "cms-ml-detail-card-list-1": productCardListComp,
    "cms-ml-detail-card-list-2": highlightedCardListComp,
    "cms-ml-detail-card-list-3": eventsCardListComp,
    "cms-ml-detail-card-list-4": channelCardsListComp,
    "cms-ml-detail-card-list-5": moreEventsCardsListComp,
    "cms-atom-text-1": title,
    "cms-atom-text-2": moreInfoText,
    alias,
  } = props;

  if (!buttonList && productCardList && !title) {
    return null;
  }
  const [selectedCategory, setselectedCategory] = useState("todos");
  const [version, setVersion] = useState("");

  const productCardList = productCardListComp?.["cms-ml-detail-card-1"];
  const highlightedCardList = highlightedCardListComp?.["cms-ml-detail-card-1"];
  const eventsCardList = eventsCardListComp?.["cms-ml-detail-card-1"];
  const channelCardList = channelCardsListComp?.["cms-ml-detail-card-1"];
  const moreEventsCardsList = moreEventsCardsListComp?.["cms-ml-detail-card-1"];
  const textLinkProps = props["cms-ml-alert-1"];

  // Filtramos segun categoria del boton
  const filteredProductCards = filterByCategory(
    productCardList,
    selectedCategory,
  );
  const filteredHighlightedCards = filterByCategory(
    highlightedCardList,
    selectedCategory,
  );
  const filteredEventsCards = filterByCategory(
    eventsCardList,
    selectedCategory,
  );
  const filteredMoreEventsCards = filterByCategory(
    moreEventsCardsList,
    selectedCategory,
  );

  // Juntamos las filas de cards para mapearlas a continuacion
  const secondaryCardLists = [
    { cards: filteredHighlightedCards, cardProps: highlightedCardListComp },
    { cards: filteredEventsCards, cardProps: eventsCardListComp },
    { cards: filteredMoreEventsCards, cardProps: moreEventsCardsListComp },
  ];

  useEffect(() => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    const filters = params.get("filters");
    if (filters) {
      setselectedCategory(filters);
    }

    // Extraemos secure
    const secureStorage = new SecureLocalStorage();
    const ts = secureStorage.getItem("ts");

    if (ts && ts.userName) {
      setVersion("mimovistar")
    }
  }, []);

  return (
    <section id={blockName || ""} className="filter-cards">
      {/* TITLE */}
      {title && (
        <TextInfo
          className="container filter-cards--title"
          {...title}
          kind="h"
          level="2"
          cyData="FilterCards Title"
          cmsHandler={cmsHandler}
        />
      )}
      {/* FILTER BUTTONS */}
      {buttonList && (
        <FilterButtons
          selectedCategory={selectedCategory}
          setselectedCategory={setselectedCategory}
          buttonList={buttonList}
          cmsHandler={cmsHandler}
        />
      )}
      <Alert {...textLinkProps} cmsHandler={cmsHandler} />
      {/* MAIN CARDS */}
      {renderCardList({
        cards: filteredProductCards,
        cardProps: productCardListComp,
        cmsHandler,
        blockName,
        alias,
        innerBlockName: "cms-ml-detail-card-list-1",
        index: "",
      })}
      {/* MAIN CARDS CANALES A LA CARTA */}
      {/* Caso de canales a la carta cuando filtramos por boton para poder eliminar bien */}
      {selectedCategory &&
        selectedCategory === "canales-a-la-carta" &&
        renderCardList({
          cards: channelCardList,
          cardProps: channelCardsListComp,
          cmsHandler,
          blockName,
          alias,
          innerBlockName: "cms-ml-detail-card-list-4",
          index: "",
        })}

      {/* MORE INFO TEXT */}
      {selectedCategory &&
        version !== "mimovistar" &&
        (selectedCategory === "todos" ||
          selectedCategory === "cine-y-series") && (
          <TextInfo
            className="container"
            {...moreInfoText}
            cyData="FilterCards MoreInfoText"
            cmsHandler={cmsHandler}
          />
        )}
      {/* COLLAPSED CHANNELS */}
      {selectedCategory && selectedCategory === "todos" && (
        <CollapsedDetailCardList
          cards={channelCardList}
          blockName={`${blockName}.cms-ml-detail-card-list-4`}
          alias={alias}
          cmsHandler={cmsHandler}
        />
      )}

      {/* SECONDARY CARDS */}
      {secondaryCardLists.map(({ cards, cardProps }, index) =>
        renderCardList({
          cards,
          cardProps,
          cmsHandler,
          blockName,
          alias,
          innerBlockName: `cms-ml-detail-card-list-${index + 2}`,
          index,
        }),
      )}
      <style jsx>{`.filter-cards {
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
  background-color: white;
  .carousel .carousel-window .carousel-item-wrapper {
    padding: 0;
  }
  &--column {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }
}
`}</style>
    </section>
  );
};

export default FilterCards;
